import { render, staticRenderFns } from "./Remittances.vue?vue&type=template&id=619293a6&scoped=true"
import script from "./Remittances.vue?vue&type=script&lang=js"
export * from "./Remittances.vue?vue&type=script&lang=js"
import style0 from "./Remittances.vue?vue&type=style&index=0&id=619293a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619293a6",
  null
  
)

export default component.exports